import { useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';
import { HandHeart } from 'lucide-react';
import PageHero from '@/components/PageHero';

export default function Prayer() {
  const [form, setForm] = useState({ name: '', email: '', request: '', is_private: false });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/prayer-requests', form);
      toast.success('Your prayer request has been received. We are praying with you.');
      setForm({ name: '', email: '', request: '', is_private: false });
    } catch {
      toast.error('Could not submit. Please try again.');
    }
  };
  return (
    <div>
      <PageHero slug="prayer" overline="Bear One Another's Burdens" heading="Prayer Request Portal" text={'"The effectual fervent prayer of a righteous man availeth much." — James 5:16'} />
      <section className="bg-white py-20">
        <div className="max-w-2xl mx-auto px-6">
          <form onSubmit={submit} className="card-tactile p-8 space-y-4">
            <div className="flex items-center gap-3 mb-2"><HandHeart className="w-6 h-6 text-gold" /><div className="font-serif text-2xl text-royal font-bold">Share Your Request</div></div>
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Name</label>
              <input data-testid="prayer-name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Email (optional)</label>
              <input data-testid="prayer-email" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Your Request</label>
              <textarea data-testid="prayer-request" required rows="6" value={form.request} onChange={e => setForm({ ...form, request: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <label className="flex items-center gap-2 text-sm text-charcoal-muted">
              <input type="checkbox" data-testid="prayer-private" checked={form.is_private} onChange={e => setForm({ ...form, is_private: e.target.checked })} className="rounded" />
              Keep my request private (shared only with prayer team)
            </label>
            <button type="submit" data-testid="prayer-submit-btn" className="btn-royal w-full justify-center">Submit Prayer Request</button>
          </form>
        </div>
      </section>
    </div>
  );
}
